import { Col, Row, Typography, Breadcrumb } from "antd";
import { FC } from "react";
import { HomeOutlined } from '@ant-design/icons';

const StaticPageBanner: FC<{title: string, description: string, date?: Date, category?: any}> = ({title, description, date, category}) => {
    const { Text } = Typography;
    
    return ( 
        <Row gutter={[20, 20]} className="!bg-[#e7eaed] !py-4 lg:!py-8 xl:py-16 !px-2 lg:!px-6 xxl:!px-16">
            <Col xs={24} lg={14} className="!flex !flex-col gap-2">
                <div>
                    <Text className="!text-xl sm:!text-2xl xl:!text-4xl !font-bold !text-black">
                        {title}
                    </Text>
                </div>
                <div className="!flex !flex-col gap-2">
                    <Text className="!text-sm sm:!text-lg !text-black">
                        {description}
                    </Text>
                    {date && (
                        <Text className=" !text-gray-500 !text-[14px]">
                            {date.toLocaleDateString("tr-TR", {
                                year: "numeric",
                                month: "long",
                                day: "numeric"
                            })}
                        </Text>
                    )}
                </div>
            </Col>
            
            {category && (
                <Col xs={24} lg={10} className="!flex items-center justify-end">
                    <Breadcrumb className="!text-sm sm:!text-base">
                        <Breadcrumb.Item href="/">
                            <HomeOutlined />
                        </Breadcrumb.Item>
                        {category.parent && (
                            <Breadcrumb.Item href={`/ilan/${category.url}`}>
                                {category.parent.name}
                            </Breadcrumb.Item>
                        )}
                       <Breadcrumb.Item href={`/ilan/${category.url}`}>
  {category.type === 1 ? "Vasıta" : category.name}
</Breadcrumb.Item>
                    </Breadcrumb>
                </Col>
            )}
        </Row>
    );
}

export default StaticPageBanner;